export const arrow = size => ({
  position: 'absolute',
  zIndex: 2,
  top: 'calc(50% - 25px)',
  width: size,
  height: size,
  cursor: 'pointer',
  color: '#fff'
});
